export class DebouncedCallback {
  private timeout: ReturnType<typeof setTimeout> | undefined;

  constructor(
    private readonly callback: () => void,
    private readonly delayInMs: number = 20_000,
  ) {}

  activate() {
    this.cancel();
    this.timeout = setTimeout(() => {
      this.timeout = undefined;
      this.callback();
    }, this.delayInMs);
  }

  cancel() {
    if (!this.timeout) {
      return;
    }

    clearTimeout(this.timeout);
    this.timeout = undefined;
  }
}
